import { render, staticRenderFns } from "./customerCareRemaining.vue?vue&type=template&id=456149c6&"
import script from "./customerCareRemaining.vue?vue&type=script&lang=ts&"
export * from "./customerCareRemaining.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports